export default __webpack_public_path__ + "/dist/images/1362003.png";